import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api, resolveMedia } from "../../lib/api";
import { useLang } from "../../i18n";
import { Reveal, SectionHeading } from "../Reveal";

export default function ImpactGallery({ limit = 6, showMore = true }) {
  const { pick, lang } = useLang();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/gallery").then((res) => setItems(res.data.items || [])).catch(() => {});
  }, []);

  const shown = limit ? items.slice(0, limit) : items;

  return (
    <section data-testid="impact-gallery-section" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <SectionHeading
          overline={pick({ hi: "तस्वीरों में", en: "In Pictures" })}
          title={pick({ hi: "हमारा जमीनी प्रभाव", en: "Our Grassroots Impact" })}
          description={pick({
            hi: "हम सीधे समुदाय के बीच काम करते हैं — ये तस्वीरें हमारी वास्तविक गतिविधियों की झलक हैं।",
            en: "We work directly within communities — these pictures are glimpses of our real activities.",
          })}
          testid="impact-gallery-heading"
        />
        <div className="mt-14 columns-1 sm:columns-2 lg:columns-3 gap-5 [column-fill:balance]">
          {shown.map((item, i) => (
            <Reveal key={item.id || i} i={i % 3} className="mb-5 break-inside-avoid">
              <figure
                data-testid={`impact-photo-${i}`}
                className="group relative rounded-2xl overflow-hidden border border-ngo-deep/10 shadow-[0_8px_30px_rgba(23,107,58,0.08)]"
              >
                <img
                  src={resolveMedia(item.url)}
                  alt={`${item.caption_hi} — Anansha Welfare Society, Varanasi`}
                  title={item.caption_hi}
                  loading="lazy"
                  className="w-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-ngo-forest/90 to-transparent px-5 pt-12 pb-4 text-sm font-medium text-ngo-cream translate-y-2 opacity-90 group-hover:translate-y-0 group-hover:opacity-100 transition-[transform,opacity] duration-300">
                  {lang === "hi" ? item.caption_hi : item.caption_en || item.caption_hi}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
        {showMore && (
          <Reveal className="mt-10 text-center">
            <Link
              to="/gallery"
              data-testid="impact-gallery-more-btn"
              className="group inline-flex items-center gap-2.5 px-7 py-3.5 rounded-full border-2 border-ngo-deep text-ngo-deep font-semibold hover:bg-ngo-deep hover:text-white transition-colors duration-300"
            >
              {pick({ hi: "पूरी गैलरी देखें", en: "View Full Gallery" })}
              <ArrowRight size={17} className="group-hover:translate-x-1 transition-transform duration-300" />
            </Link>
          </Reveal>
        )}
      </div>
    </section>
  );
}
